import { GET_PROMOSI, SET_LOADING_PROMOSI, SET_PAGINATION_PROMOSI } from '../constant';

const initialState = {
  promosi: [],
  promosiPagination: 0,
  loadingPromosi: false,
  totalPromosi: 0,
};

const promosiReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING_PROMOSI: {
      return {
        ...state,
        loadingPromosi: action?.payload,
      };
    }
    case SET_PAGINATION_PROMOSI: {
      return {
        ...state,
        promosiPagination: action?.payload,
      };
    }
    case GET_PROMOSI: {
      return {
        ...state,
        promosi: action?.payload?.data || [],
        totalPromosi: action?.payload?.total,
        loadingPromosi: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default promosiReducer;
